import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Link, Navigate, useLocation } from "react-router-dom"
import { HomeBgImg, LogoBigImg } from "@/assets"
import { useAppSelector } from "@/store"
import { PlayerSelectors } from "@/store/slices/player"
import {
  EmailOtpForm,
  GoogleAuthButton,
  TelegramAuthButton,
  YandexAuthButton
} from "@/ui/auth"
import styles from "./Register.module.scss"

export const Register: FC = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const isAuthorized = useAppSelector(PlayerSelectors.selectIsAuthorized())

  if (isAuthorized) return <Navigate to="/" replace />

  const prefillEmail = (location.state as { prefillEmail?: string } | null)
    ?.prefillEmail

  return (
    <div className={styles.Register}>
      <img src={HomeBgImg} alt="background" className={styles.Register_bg} />
      <img src={LogoBigImg} alt="logo" className={styles.Register_logo} />
      <div className={styles.Register_title}>{t("register.title")}</div>

      <div className={styles.Register_providers}>
        <EmailOtpForm mode="register" initialEmail={prefillEmail} />

        <div className={styles.Register_divider}>
          <span>{t("register.or")}</span>
        </div>

        <div className={styles.Register_providersFast}>
          <TelegramAuthButton mode="register" />
          <GoogleAuthButton mode="register" />
          <YandexAuthButton mode="register" />
        </div>
      </div>

      <div className={styles.Register_footer}>
        {t("register.haveAccount")}
        <Link to="/login" className={styles.Register_footer_link}>
          {t("register.loginCta")}
        </Link>
      </div>
    </div>
  )
}
